<template>
    <v-card-title component="ShortlistCharacterHeader" class="title" @click="selectCharacter(character)">
        <div class="name">{{ character.meno }}</div>
        <btn
            v-if="hasPermissionTo('project.video.request')"
            :icon="'voice_chat'"
            size="icon"
            color="transparent"
            @click.stop="openProjectVideoDialog(character)"
        />
    </v-card-title>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'ShortlistCharacterHeader',

    props: {
        character: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {};
    },

    async mounted() {},

    computed: {
        ...mapGetters(['getProject', 'getColorById', 'hasPermissionTo', 'getSelectedCharacter']),
    },

    methods: {
        ...mapActions(['setCharacter']),
        ...mapMutations(['setProjectVideoDialog']),

        selectCharacter(character) {
            if (character.id === this.getSelectedCharacter.id) {
                return;
            }
            this.setCharacter(character);
        },

        openProjectVideoDialog(character) {
            this.setProjectVideoDialog({ visible: true, character: character });
        },
    },

    components: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='ShortlistCharacterHeader'] {
    .font;
    justify-content: space-between;
    flex-wrap: nowrap;
    font-size: 15px !important;
    padding: 6px 6px 6px 8px !important;
    font-weight: 700;
    color: black;
    //background: rgba(255, 255, 255, 0.3);
    border-radius: 0;
    cursor: pointer;

    .name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: rgba(255, 255, 255, 0);
        padding: 0 7px;
        border-radius: 10px;
    }
}
</style>
